<template>
  <div class="menu-container">
    <b-button 
      class="menu-toggle d-900-none" 
      @click="isMenuOpen = !isMenuOpen"
      variant="light"
    >
      <font-awesome-icon :icon="isMenuOpen ? faTimes : faBars" />
      <span class="ml-2">Menu</span>
    </b-button>

    <b-collapse id="side-menu-collapse" v-model="isMenuOpen" class="d-900-block">
      <b-list-group class="custom-side-menu">
        <b-list-group-item 
          v-for="item in menuItems" 
          :key="item.name"
          :href="item.href" 
          :disabled="item.disabled"
          :active="isActive(item)"
          @click="handleClick(item)"
        >
          {{ item.name }}
          <font-awesome-icon :icon="item.icon" class="menu-icon" />
        </b-list-group-item>
      </b-list-group>
    </b-collapse>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { 
  faDollarSign, 
  faChartLine,
  faShoppingBag,
  faBookOpen,
  faCheck,
  faUser,
  faBars, // Added
  faTimes,
  faBalanceScale // Added
} from '@fortawesome/free-solid-svg-icons';

export default {
  name: 'SideMenu',
  props: {
    activeItem: {
      type: String,
      default: 'Analytics'
    },
    items: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isMenuOpen: false, // Controls the collapse
      faBars,
      faTimes,
      defaultMenuItems: [
        { name: 'Sales', href: '/manage/tp-sales', icon: faDollarSign, disabled: false },
        { name: 'Menu', href: '/manage/tp-analytics', icon: faBookOpen, disabled: false },
        { name: 'Approve Sales', href: '/manage/tp-verification', icon: faCheck, disabled: false },
        { name: 'Catering', href: '/manage/tp-catering', icon: faShoppingBag, disabled: false },
        { name: 'Compare', href: '/manage/tp-compare', icon: faBalanceScale, disabled: false },
        // { name: 'Timeline', href: '/manage/tp-timeline', icon: faChartLine, disabled: true },
        { name: 'Customers', href: '/manage/tp-customers', icon: faUser, disabled: true }
      ]
    };
  },
  computed: {
    menuItems() {
      return this.items.length > 0 ? this.items : this.defaultMenuItems;
    }
  },
  methods: {
    isActive(item) {
      return item.name === this.activeItem;
    },
    handleClick(item) {
      this.$emit('menu-change', item.name);
      // Optional: Close menu after clicking an item on mobile
      if (window.innerWidth < 900) {
        this.isMenuOpen = false;
      }
    }
  }
};
</script>

<style scoped>
/* Container Logic */
.menu-container {
  width: fit-content;
}

.custom-side-menu {
  width: 11em !important;
  border-radius: 0 0.5em 0.5em 0 !important;
  background-color: antiquewhite;
  border-left: none;
  overflow: hidden;
  flex-shrink: 0;
  height: fit-content;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
}

/* Toggle Button Styling */
.menu-toggle {
  display: none; /* Hidden by default */
  margin-bottom: 10px;
  border: 1px solid #ddd;
  background-color: whitesmoke !important;
  color: #4b0082 !important;
}

/* Mobile/Tablet Adjustments (Under 900px) */
@media (max-width: 899.98px) {
  .menu-toggle {
    display: block; /* Show hamburger */
  }

  .menu-container {
    width: 100% !important; /* Full width on mobile */
    border-radius: 0.5em !important;
    position: absolute; /* Float over content if preferred */
    z-index: 1000;
    top: 0em;
  }
  
  /* Force display none/block based on collapse state for responsiveness */
  .d-900-none { display: block; }
}

/* Desktop Logic (900px and up) */
@media (min-width: 900px) {
  .d-900-block {
    display: block !important; /* Ensure menu is always visible on desktop */
  }
  .menu-toggle {
    display: none !important;
  }
}

/* Existing Styles */
.custom-side-menu >>> .list-group-item {
  border-radius: 0 !important;
  border: none;
  padding: 0.75rem 1rem;
  cursor: pointer;
}

.custom-side-menu >>> .list-group-item.active {
  background-color: #e6e6fa !important;
  color: #4b0082 !important;
  font-weight: bold;
}

.menu-icon {
  font-size: 1rem;
  opacity: 0.8;
  float: right;
}

.custom-side-menu >>> .list-group-item.disabled {
  color: lightgray !important;
}
</style>